import React from 'react';

import { appMethod as app } from '@utils/app';
import './Map.less';


/*
* @param { Number } latitude 中心经度。具体参考微信小程序map组件参数，下同。
* @param { Number } longitude 中心纬度。
* @param { Number } scale 缩放级别，取值范围为3-20。默认16
* @param { Array.<marker> } markers 标记点
* @param { Array.<circle> } circles 圆
* @param { Array.<control> } controls 控件
* @param { function } bindmarkertap 点击标记点时触发
* @param { function } bindcontroltap 点击控件时触发
* @param { function } bindregionchange 视野发生变化时触发的事件
*
* 另外组件会接收className 和 style 属性
*
* TODO： 注意很多参数并不完整。很多没有用到的就没有实现
*/

export class Map extends React.Component {
  constructor(props) {
    super(props);
    this.mapInstance = null;
    this.markersArr = [];
    this.circleInstance = null;
    this.controlsArr = [];

    this.latitude = this.props.latitude;  //中心经度。
    this.longitude = this.props.longitude; //中心纬度。
  }

  componentDidMount() {
    if(!this.latitude || !this.longitude){
      console.error('map组件，经纬度是必填参数');
      return;
    }

    this.mapInstance = new qq.maps.Map(document.getElementById("map-inner") , {
      zoom: +this.props.scale || 16,
      zoomControl: false,
      panControl: false,
      mapTypeControl: false
    });
    this.mapInstance.panTo(new qq.maps.LatLng(this.latitude, this.longitude));

    this.props.markers && this.setMarkers(this.props.markers);

    this.props.circles && this.setCircle(this.props.circles);

    this.props.controls && this.setcontrols(this.props.controls);

    qq.maps.event.addListener(this.mapInstance, 'dragend', (e) => {
      this.props.bindregionchange && this.props.bindregionchange({
        type: 'end',
        causedBy: 'drag'
      })
    });
    qq.maps.event.addListener(this.mapInstance, 'dragstart', (e) => {
      this.props.bindregionchange && this.props.bindregionchange({
        type: 'begin',
        causedBy: 'drag'
      })
    });
    qq.maps.event.addListener(this.mapInstance, 'zoom_changed', (e) => {
      this.props.bindregionchange && this.props.bindregionchange({
        type: 'end',
        causedBy: 'scale'
      })
    });
  }

  componentDidUpdate(prevProps){    
    this.props.markers && this.setMarkers(this.props.markers);

    this.props.circles && this.setCircle(this.props.circles);

    this.props.controls && this.setcontrols(this.props.controls);
  }

  // 多个设置标记
  setMarkers(ms){
    this.markersArr.map((item, index) => {
      item.setMap(null);
    });
    this.markersArr = [];
    ms.map((item, index) => {
      this.setMarker(item);
    });
  }

  // 设置标记
  setMarker(data){
    if(!data.latitude || !data.longitude){
      console.error('map组件markers属性如果有，markers属性里面的字段latitude，longitude是必填参数。可以参考微信小程序map组件');
      return;
    }
    let options = {
      map: this.mapInstance,
      position: new qq.maps.LatLng(data.latitude, data.longitude),
      title: data.title || ''
    };
    if(data.iconPath){
      let size = '';
      let origin = new qq.maps.Point(0, 0);
      if(data.width || data.height){
        size = new qq.maps.Size(data.width || 20, data.height || 30)
      }
      options.icon = new qq.maps.MarkerImage(
        data.iconPath,
        size,
        origin,
        null,
        size
      )
    }
    if(data.zIndex){
      options.zIndex = data.zIndex;
    }

    let marker = new qq.maps.Marker(options);
    this.markersArr.push(marker);

    qq.maps.event.addListener(marker, 'click', () => {
      this.props.bindmarkertap && this.props.bindmarkertap({
        markerId: data.id || ''
      })
    });
  }

  // 设置圆
  setCircle(data){
    if(!data.latitude || !data.longitude || !data.radius){
      console.error('map组件circle属性如果有，circle属性里面的字段latitude，longitude，radius是必填参数。可以参考微信小程序map组件');
      return;
    }
    this.circleInstance && this.circleInstance.setMap(null);
    this.circleInstance = new qq.maps.Circle({
        map: this.mapInstance,
        center: new qq.maps.LatLng(data.latitude, data.longitude),
        radius: data.radius,
        fillColor: data.fillColor || '',
        strokeWeight: data.strokeWidth || ''
    });
  }

  // 多个设置控件
  setcontrols(cs){
    this.controlsArr.map((item, index) => {
      item.remove();
    });
    this.controlsArr = [];
    cs.map((item, index) => {
      this.setcontrol(item);
    });
  }

  // 设置控件
  setcontrol(data){
    if(!data.iconPath){
      console.error('map组件controls属性如果有，iconPath是必填参数。可以参考微信小程序map组件');
      return;
    }
    let control = document.createElement("div");
    control.style.cssText = (data.position && data.position.width ? 'width: ' + data.position.width +'px;' : '') + (data.position && data.position.height ? 'height: ' + data.position.height +'px;' : '') + 'margin-left: ' + (data.position && data.position.left ? data.position.left : 0) + 'px; margin-top:' + (data.position && data.position.top ? data.position.top : 0) + 'px;';
    control.innerHTML = '<img style="width: 100%; height: 100%;" src="' + data.iconPath + '" />';
    control.index = 3;

    this.mapInstance.controls[qq.maps.ControlPosition.LEFT_TOP].push(control);
    this.controlsArr.push(control);

    if(data.clickable){
      qq.maps.event.addListener(control, "click", () => {
        this.props.bindcontroltap && this.props.bindcontroltap({
          controlId: data.id || ''
        })
      });
    }
  }

  getCenterLocation = (options) => {
    let latlng = this.mapInstance.getCenter();
    if(latlng){
      typeof options.success === 'function' && options.success({
        longitude: latlng.lng,
        latitude: latlng.lat
      });
    }else{
      typeof options.fail === 'function' && options.fail();
    }
    typeof options.complete === 'function' && options.complete();
  }
  
  render() {
    return (
      <div className={`jisu-component map map-wrapper ${this.props.className}`} style={this.props.style}>
        <div className="map-inner" id="map-inner" style={this.props.style}></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/jisu-component/map/Map.jsx